"use client";

import ContactForm from "@/components/frontend/contact/ContactForm";
import { Phone, MailOpen, MapPin } from "lucide-react";
import Image from "next/image";
import { GRID_CLASSES } from "@/libs/grid/grid";

const contactInfo = [
    {
        icon: Phone,
        title: "0711 928928"
    },
    {
        icon: MailOpen,
        title: "mobettsagrocenter@gmail.com"
    },
    {
        icon: MapPin,
        title: "Loncom House, KCB Menengai Branch building, Ground floor, Nakuru, Kenya"
    }
];

export default function ContactUs() {
    return (
        <div className="relative flex items-start w-full min-h-screen bg-black text-white overflow-hidden">
            <div
                className="absolute inset-0 z-0"
                style={{
                    backgroundImage:
                        "radial-gradient(91.7% 54.32% at 50% -.02%, var(--color-primary) 0%, rgba(0, 0, 0, 0) 100%)",
                }}
            />
  
            {/* <Image
                src="/images/contact.png"
                alt="contact-banner"
                fill
                className="object-cover object-center"
                sizes="100vw"
            /> */}

            <div className={`relative grid ${GRID_CLASSES} z-10 w-full py-12 md:py-0`}>

                <div className="col-span-6 md:col-start-1 md:col-span-7 flex flex-col items-center gap-3 pt-24 lg:mt-50 text-white">
                    <h3 className="font-semibold uppercase text-4xl md:text-7xl">
                        Get <span className="text-accent">in-touch</span> <br/>with us today
                    </h3>
                    <p className="text-base text-center max-w-[32ch]">
                        For all your orders and inquires all your orders and inquires
                    </p>
                    <span className="w-24 h-1 bg-white"></span>
                </div>

                <div className="col-span-6 mt-8 px-6 flex flex-col w-full gap-2 md:gap-6">
                    <div className="flex flex-col items-center py-4 px-1 gap-4 w-full">
                        {contactInfo.map((c, i) => {
                            const Icon = c.icon;
                            return (
                                <div key={i} className="flex lg:items-start bg-white text-black px-4 py-2 rounded-xl gap-4">
                                    <Icon className="w-5 h-5 md:w-8 md:h-8 shrink-0" />
                                    <h4 className="text-base lg:text-lg leading-5 max-w-[22ch] wrap-break-word min-w-0">{c.title}</h4>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="col-span-6 flex flex-col px-4 mt-6 gap-6 z-10">
                    <div className="flex flex-col border border-accent/40 bg-accent/40 backdrop-blur-2xl rounded-xl py-4 px-4 gap-4 w-full">
                        <h3 className="text-2xl lg:text-4xl font-medium text-white">
                                Send us a message
                        </h3>
                        <ContactForm />
                    </div>
                </div>

                </div>

            </div>
    );
}